import { useEffect, useRef } from 'react';

import { ICartPrice, IEcommerceServices } from '@model';
import { useTrackViewCartPageEvent } from '@services/ecommerceService';
import { hasFreeDeliveryForCart } from '@utils/delivery';

import { useCartPageContext } from '../context';
import { createEcommerceCheckout } from '../ecommerce';
import { IBenefits, IProduct, IServices } from '../model';

export const useCartPageEcommerce = (
  products: IProduct[],
  pricesSummary: ICartPrice,
  availableServices: IEcommerceServices,
  services: IServices,
  benefits: IBenefits,
) => {
  const {
    settings: {
      freeDelivery,
      freeDeliveryGlobalFrom,
      freeDeliveryGlobalTo,
      minimalPriceLimit,
      freeDeliveryGlobalLimit,
    },
    state: {
      pricesSummary: { priceProductsSummary, discountWithoutDelivery },
    },
  } = useCartPageContext();
  const triggeredPageView = useRef<boolean>(false);
  const trackViewEvent = useTrackViewCartPageEvent();

  useEffect(() => {
    if ((products.length > 0 || services.discoveryBox.length > 0) && !triggeredPageView.current) {
      triggeredPageView.current = true;
      const hasFreeDelivery = hasFreeDeliveryForCart(
        minimalPriceLimit,
        freeDelivery,
        freeDeliveryGlobalLimit,
        freeDeliveryGlobalFrom,
        freeDeliveryGlobalTo,
        benefits,
        priceProductsSummary,
        discountWithoutDelivery,
      );
      trackViewEvent({
        ...createEcommerceCheckout(products, pricesSummary, services, availableServices, hasFreeDelivery),
      });
    }
  }, [
    products,
    pricesSummary,
    trackViewEvent,
    availableServices,
    services,
    benefits,
    minimalPriceLimit,
    freeDelivery,
    freeDeliveryGlobalLimit,
    freeDeliveryGlobalFrom,
    freeDeliveryGlobalTo,
    priceProductsSummary,
    discountWithoutDelivery,
  ]);
};
